import React from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import LoginVM from "../viewmodel/LoginVM";
import CInput from "../../components/CInput";
import LanguageSelector from "../../main/LanguageSelector";
import { useTranslation } from "react-i18next";

const LoginView = ({ cLogo, cBgImg, handleToastOpen }) => {
  const { email, setEmail, handleLogin, loading } = LoginVM({ handleToastOpen });
  const { t } = useTranslation();

  return (
    <div
      style={{
        overflow: "hidden",
        width: "100vw",
        height: "100vh",
        backgroundImage: `url(${cBgImg})`,
        backgroundSize: "cover",
        position: "relative"
      }}
    >
      {/* Language Selector positioned in top-right corner */}
      <div
        style={{
          position: "absolute",
          top: "1em",
          right: "1em",
          zIndex: 10
        }}
      >
        <LanguageSelector />
      </div>

      <Card
        style={{
          padding: "4em",
          maxWidth: 320,
          minWidth: 200,
          margin: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "10em",
        }}
      >
        <img
          src={cLogo}
          alt="Company Logo"
          style={{
            width: "100%",
            height: "50%",
            marginBottom: "3em"
          }}
        />

        <CInput
          cId="login_email"
          cHintText={t('all_record')}
          cOnChange={(e) => setEmail(e.target.value)}
          cIsRequired="true"
          cFullWidth="true"
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            borderRadius: "0.5em",
            marginTop: "1.5em",
          }}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? t('logging_in') || "Logging in..." : t('login')}
        </Button>
      </Card>
    </div>
  );
};

export default LoginView;